import axios from 'axios';

import type {
  IContactSalesFormBody,
  IContactSalesReponse,
} from '@/app-package';

const contactSalesForm = async (body: IContactSalesFormBody) => {
  const url = `/sales_form`;

  await axios.post<IContactSalesReponse>(url, body);
};

export default contactSalesForm;
